import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsService } from './permissions.service';
import { FORBIDDEN_ROUTE } from './permissions.paths';

/**
 * Lets only super admins through, and denies everyone else with a `UrlTree`
 * to the 403 page, the same way `permissionsGuard` does.
 *
 * Super admin is a user-level role (`usuario.isSuperAdmin`), not a grant on
 * the active project, so this guard reads nothing else: no route data, no
 * resource permission, no crew type. A user holding every flag on `Usuario`
 * or `Project` is still denied. It reads the flag on each call, so it follows
 * sign-out (`clearPermissions()`) and fails closed before permissions load.
 *
 * Typed for both hooks because it is wired as `canMatch` on the `admin`
 * parent and as `canActivate` on each of its children. It reads nothing off
 * the route, so one function serves both.
 */
export const onlySuperadminGuard: CanActivateFn & CanMatchFn = () => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);

  return permissionsService.isSuperAdmin() || router.parseUrl(FORBIDDEN_ROUTE);
};
